import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const listSelectionSlice = createSlice({
  name: 'listSelection',
  initialState: {
    movementIds: [],
    partialTripIds: [],
    routeIds: []
  },
  reducers: {
    listSelectionReducer: (state, action) => {
      state.movementIds = action.payload.movementIds;
      state.partialTripIds = action.payload.partialTripIds;
      state.routeIds = action.payload.routeIds;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { listSelectionReducer } = listSelectionSlice.actions
export default listSelectionSlice.reducer 
